import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconQueue — 队列：三条错落行 + 队首人点，表达呼叫/坐席/任务队列实时排布
 * （icon-map.md §3.2 ⑥）。圆点后画，与行端圆帽平滑相接。 */
export default function IconQueue(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path d="M3 4.5h10" />
      <path d="M3 8h7" />
      <path d="M3 11.5h5" />
      <circle cx="10" cy="8" r="0.9" />
    </BizIconSvg>
  );
}
